
<div
  :class="
    classes(
      n(),
      n(`-align--${align}`),
      [clickable, n(`--clickable`)],
      [bordered, n(`--bordered`)],
      [state.padded, n(`--padded`)]
    )
  "
  :role="clickable ? 'button' : undefined"
  :tabindex="clickable ? 0 : undefined"
  @click="handleClick"
>
  <div v-if="leftIcon" :class="classes(n('left-icon'))">
    <component :is="leftIcon" />
  </div>
  <div :class="classes(n('content'))">
    <div :class="classes(n('left'))">
      <div :class="classes(n('left-content'))">
        <div v-if="title || $slots.title" :class="classes(n('title'))">
          <slot name="title">
            {{ title }}
          </slot>
        </div>
        <div
          v-if="description || $slots.description"
          :class="classes(n('description'))"
        >
          <slot name="description">
            {{ description }}
          </slot>
        </div>
      </div>
    </div>
    <div :class="classes(n('right'), n(`right--${align}`))">
      <div :class="classes(n('right-content'))">
        <div
          v-if="note || $slots.note"
          :class="
            classes(n('note'), [extra || $slots.extra, n('note--with-extra')])
          "
        >
          <slot name="note">
            {{ note }}
          </slot>
        </div>
        <div v-if="extra || $slots.extra" :class="classes(n('extra'))">
          <slot name="extra">
            {{ extra }}
          </slot>
        </div>
      </div>
      <Badge v-if="dot" dot :class="classes(n('dot'))" />
      <div v-if="arrow || rightIcon" :class="classes(n('right-icon'))">
        <component :is="rightIcon" v-if="rightIcon" />
        <ArrowRightIcon v-else-if="arrow" />
      </div>
    </div>
  </div>
</div>
